export const isMpaUrl = window.location.hostname.toLowerCase().startsWith("mpa.");
